import { render } from "./TermsTabs.vue?vue&type=template&id=af59ff1e&scoped=true"
import script from "./TermsTabs.vue?vue&type=script&lang=js"
export * from "./TermsTabs.vue?vue&type=script&lang=js"

import "./TermsTabs.vue?vue&type=style&index=0&id=af59ff1e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af59ff1e"]])

export default __exports__